<div class="model-predictions-content-container">
   <div class="container-start">
      <div class="section-rules">
        <div class="rules-block entry-rules ">
          <div class="entry color-margin">
            <fa-icon [icon]="faArrowRightToBracket" class="fa-2x icon-margin" ></fa-icon>
          </div>
          <div class="rules">
            <div class="title-container"><span>Entry Strategy</span></div>
            <div class="rules-list-container">
              <div class="rule">
                <div><span>The difference between the model predictions and the forward curve is:</span></div>
                <div class="rules-inputs">
                  <span>greater than <input type="number" id="entryDifferencePercentage" [(ngModel)]="differencePercentage" (input)="storeCachedRules()"  maxlength="3" size="3" /> %</span>
                  <span> or </span>
                  <span><input type="number" id="entryDifferenceValue" [(ngModel)]="differenceValue" (input)="storeCachedRules()" maxlength="3" size="3" /> $/mmbtu</span>
                </div>
             
                <!-- <input type="number" id="entryDifferencePercentage" [(ngModel)]="differencePercentage" (input)="clearValue('percentage')" maxlength="3" size="3" /> % or  -->
                <!-- <input type="number" id="entryDifferenceValue" [(ngModel)]="differenceValue" (input)="clearValue('value')" maxlength="3" size="3" /> $/mmbtu -->
              </div>
            </div>
          </div>
        </div>
   
        <div class="rules-block exit-rules">
          <div class="color-margin exit">
            <fa-icon [icon]="faArrowRightFromBracket" class="fa-2x icon-margin"></fa-icon>
          </div>
          <div class="rules">
            <div class="title-container"><span>Exit Strategy</span></div>
            <div class="rules-list-container">
              <div class="rule" *ngIf="isRequiredByModel() ">
                <!-- <span><input type="radio" name="exitStrategy" class="radio-margin" value="difference" (change)="onStrategyChange('difference')" /> </span> -->
                <span>The difference between the model predictions and the forward curve is greater than 
                  <input type="number" id="exitDifferencePercentage" 
                    (input)="storeCachedRules()"
                    [(ngModel)]="exitDifferencePercentage" 
                    [disabled]="selectedStrategy !== 'difference'" maxlength="3" size="3" /> % or 
                  <input type="number" id="exitDifferenceValue" 
                  (input)="storeCachedRules()"
                  [(ngModel)]="exitDifferenceValue" 
                  [disabled]="selectedStrategy !== 'difference'" maxlength="3" size="3" /> $/mmbtu</span>
              </div>
          
              <div class="rule">
                <!-- <span><input type="radio" name="exitStrategy" value="stopLoss" (change)="onStrategyChange('stopLoss')" />  </span> -->
                <span><strong>Stop loss</strong> | Loss is greater than 
                  <input type="number" id="stopLossPercentage" 
                    (input)="storeCachedRules()"
                    [(ngModel)]="stopLossPercentage" maxlength="3" size="3" /> % or 
                  <input type="number" id="stopLossValue" 
                    (input)="storeCachedRules()"
                    [(ngModel)]="stopLossValue"   maxlength="3" size="3" /> $/mmbtu
                </span>
              </div>
   
              <div class="rule">
                <!-- <span><input type="radio" name="exitStrategy" value="takeProfit" (change)="onStrategyChange('takeProfit')" />   </span> -->
                <span><strong>Take profit</strong> | Profit is greater than 
                  <input type="number" id="takeProfitPercentage" (input)="storeCachedRules()"
                    [(ngModel)]="takeProfitPercentage"  maxlength="3" size="3" /> % or 
                  <input type="number" id="takeProfitValue" (input)="storeCachedRules()"
                    [(ngModel)]="takeProfitValue"   maxlength="3" size="3" /> $/mmbtu
                </span>
              </div>
   
              <!-- <div class="rule">
                <span><input type="radio" name="exitStrategy" value="holding" (change)="onStrategyChange('holding')" /> </span>
                <span><strong>Holding to expiration</strong></span>
              </div> -->
              
            </div>
          </div>
        </div>

      </div>

      <div class="section-dates">

        <div class="run-container">
          <div class="test-period-container">
            <div class="text-and-calendar run-area">
              <span class="setup-text">Set test period:</span>
              <div class="date-picker-container">
                <p-datepicker 
                [(ngModel)]="predictionRange" 
                appendTo="body"
                selectionMode="range" 
                dateFormat="mm/dd/yy" 
                placeholder="Select run range" 
                (onSelect)="onRunRangeChange($event)"
                [showIcon]="true"
                [readonlyInput]="true" />
              </div>
            </div>
     
            <div class="run-button-container">
              <app-loading-button
              [label]="'Run strategy'"
              [isLoading]="isSpinnerVissible()"
              [isDisabled]="isRunButtonDisabled()"
              (clicked)="runStrategy()"
              [customClass]="'trading-strategy-run-button'"
              ></app-loading-button>
            </div>
          </div>
        </div>

        <div class="exclusion-container">
          <div class="text-and-calendar exclusion-calendar">
            <span class="setup-text">Set up to 5 periods to exclude: </span>
            <div class="date-picker-container">
              <p-datepicker 
              [(ngModel)]="rangeDates" 
              appendTo="body"
              selectionMode="range" 
              dateFormat="mm/dd/yy" 
              placeholder="Select run range" 
              (onSelect)="onDateRangeChange($event)"
              [showIcon]="true"
              [readonlyInput]="true" />
            </div>
          </div>
          <p-divider class="vertical-divider" layout="vertical"></p-divider>
          <div class="card card-full-height excluded-ranges-list">
            <div class="excluded-items-container">
               <div class="excluded-item" *ngFor="let range of exclusionDateRanges; let i = index">
                 {{ formatRange(range.start, range.end) }}
                 <fa-icon [icon]="faXmark"  (click)="removeRange(i)"></fa-icon> 
               </div>
            </div>
         </div>
        </div>

      </div>
  </div>
  
  <app-notification-popup 
  [isVisible]="isNotificationPopupOpen"
  (close)="closeNotificationPopup()"
  [errorMessage]="errorMessage()"
  [secondErrorMessage]="secondErrorMessage()"
  ></app-notification-popup>

  <div class="divider-container">
    <p-divider *ngIf="isResultVisible()"></p-divider>
  </div>
 

  <div class="strategy-results" *ngIf="isResultVisible() ">
    <div class="results-title">
      <!-- <fa-icon [icon]="faChartLine" class="fa-2x icon-margin"></fa-icon> -->
      Backtesting results for the period:
      <span class="bold-text">{{ formatRange(predictionRange?.[0], predictionRange?.[1]) }}</span>
    </div>

    <div class="columns-container">
      <div class="left-column">
        
          <div class="tables-container">
              <div class="summary-table">
                <div class="summary-title table-title">
                  <span class="bold-text">Summary</span>
                </div>
                <app-results-table
                [columnsResults]="columnsSummary" 
                [rowsResults]="rowsSummary" 
                ></app-results-table>
              </div>
            
              <div class="histogram-table">
                <div class="records-title table-title">
                  <span class="bold-text">Records</span>
                </div>
                <app-results-table
                [columnsResults]="columnsAllTrades" 
                [rowsResults]="rowsAllTrades"
                [usePagination]="true"  
                [rowsPerPage]="5"
                ></app-results-table>   
                <div class="text-button-container">
                  <button 
                  class="reset-chart-button"
                  (click)="reset()">Reset table</button>
                </div>   
              </div>

             
            </div>
       
      </div>
  
      <div class="right-column" >
    
        <div class="card card-histogram">
          <div class="card-content">
            <app-histograma class="histogram" dataKey="tradingStrategy"></app-histograma>
          </div>
        </div>
        
      </div>
    </div>
    

    <!-- <div class="right-column">
      <div class="card">
        <div class="card-content">
          <app-histograma class="histogram" dataKey="tradingStrategy"></app-histograma>
        </div>
      </div>
    </div> -->
  </div> 

</div>